import React from 'react'

const TextInput = React.forwardRef((props, ref) => (
  <input className='filters-control' {...props} ref={ref} />
))

export default TextInput
